
import React, { useEffect, useState } from "react";
import { Box, Button, Drawer, Tooltip, Typography, Grid, Card, CardMedia, CardContent, } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import details from "../../../src/assests/images/Task-detail.svg";
import arrowred from "../../../src/assests/images/arrow-red.svg";
import smoke from "../../../src/assests/images/smook-gal.png";
import { getToken } from "../../utils/utils";
import { getdrawedetails, rejectedquestions } from "./apis";
import { title } from "process";


interface TaskQuestion {
    title: string;
    subtitle: string;
    src: string;
    
  }
  
  
  
  

const rejectedImages = [
    { title: "Sample Picture 1", subtitle: "Open pack", src: smoke },
    { title: "Uploaded Picture 1", subtitle: "Open pack", src: smoke },
    { title: "Sample Picture 2", subtitle: "MRP Visible", src: smoke },
    { title: "Uploaded Picture 2", subtitle: "MRP Visible", src: smoke },
];
const BootstrapTooltip = styled((props: React.ComponentPropsWithoutRef<typeof Tooltip>) => (
    <Tooltip {...props} arrow classes={{ popper: props.className }} />
))(({ theme }) => ({
    [`& .MuiTooltip-arrow`]: {
        color: "#282829",
    },
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: "#282829",
        color: "#fff",
        fontSize: "12px",
        fontWeight: "400",
        padding: "6px 12px",
    },
}));
const RejectorDrawer = ({ SideDrawer, rows }: any) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [taskname, settaskname] = useState("");

const [tasktype, settasktype] = useState("");
const [pmientitycode, setpmientitycode] = useState("");
    

    const [drawDetails, setDrawDetails] = useState<TaskQuestion[]>([]);

    const toggleDrawer = (isOpen: boolean | ((prevState: boolean) => boolean)) => () => {
        setOpen(isOpen);
    };
    console.log(rows, "rowssssrrrrrrrrrr")
  const token = getToken();
    const handleDetailsClick = async (id: number | string) => {
        console.log(id, "vvvvvvvvvvvv");
      
        const fetchTasksdetails11 = async () => {
          try {
            const res = await rejectedquestions({ usertaskid: id }, token); 
            console.log(res.data.data, "wwwwwwwwwwwwwwww")
            const data = res.data.data.qutiondetails.flatMap((item: { question_en: any; task_question_answer: { answer: any; }; sample_picture: any; }) => [
                {
                    title: "Sample Picture 1",
                    subtitle: item.question_en,
                    // src:${process.env.REACT_APP_API_URL}/uploads$item.sample_picture , 
                    src: `${process.env.REACT_APP_API_URL}${item.sample_picture}`



                  },
                {
                  title: "Uploaded Picture 1",
                  subtitle: item.question_en,
                  src:  item.task_question_answer?.answer ,
                  
                  
                 
                }
             
              ]);
              
            settaskname(res.data.data.alldata.task_name)
            settasktype(res.data.data.alldata.task_type)
            setpmientitycode(res.data.data.alldata.pmi_entity_code)
            setDrawDetails(data);
            setOpen(true);
          } catch (error) {
            console.error("Error fetching task details:", error);
          }
        };
      
        await fetchTasksdetails11();
      };
      console.log(drawDetails, "drawDetailssssssaaaaaaaa")
    return (
        <div>
            {/* <BootstrapTooltip title="View Task Details">
                <Button onClick={() => handleDetailsClick(rows.id)}>
                    <img src={details} crossOrigin="anonymous"  alt="details" />
                   
                </Button>
            </BootstrapTooltip> */}

            {SideDrawer.map((section: any, index: React.Key | null | undefined) => (
                <Drawer key={index} open={open} onClose={toggleDrawer(false)} anchor="right">
                    <Box sx={{ background: "#fafafa" }}>
                        <Box sx={{ width: 650, padding: "24px 32px", }}>
                            <Box sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                borderBottom: "1px dashed rgba(231, 232, 233, 1)",
                                paddingBottom: "12px",
                                marginBottom: "24px",
                            }}>
                                <Box sx={{ marginTop: "80px" }}>
                                    <Typography sx={{ fontSize: "24px", fontWeight: "600" }}>{tasktype} Task</Typography>
                                </Box>
                                <Box sx={{ marginTop: "80px" }}>
                                    <Button sx={{ background: "#FEF1EF", color: "#EA001E", fontSize: "14px", fontWeight: "600" }}>Rejected</Button>
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ padding: "0 30px", maxWidth: 500, }}>
                            <Typography variant="body2" sx={{ color: "#707070", fontSize: "18px", fontWeight: "500" }}>
                                <strong>PMI Entity Code:</strong>{" "}
                                <Typography component="span" sx={{ fontWeight: "bold", color: "#042D60" }}>
                                {pmientitycode}
                                </Typography>
                            </Typography>

                            <Typography variant="body2" sx={{ marginTop: 1, color: "#707070", fontSize: "18px", fontWeight: "500" }}>
                                <strong>Task Name:</strong>{" "}
                                <Typography component="span" sx={{ fontWeight: "bold", color: "#003366" }}>
                                {taskname}                                </Typography>
                            </Typography>
                        </Box>
                        <Box>
                            <Box sx={{ padding: "20px 30px" }}>
                                <Typography sx={{ marginBottom: "30px" }} variant="h6" fontWeight="bold" gutterBottom>
                                    Images
                                </Typography>
                                <Box sx={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, 1fr)",
                                    gap: 2,
                                    justifyContent: "center",
                                }}>
                                    {drawDetails.map((image, index) => (

                                        <Card sx={{ width: "300px", borderRadius: 2, border: "none", marginRight: "20px", marginBottom: "20px", backgroundColor: index % 2 === 0 ? "#F1F2F3" : "#fff" }}>
                                            <CardContent sx={{ paddingBottom: 1 }}>
                                                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                                                    <strong>{image.title} :</strong>
                                                    <Typography component="span" sx={{ fontWeight: "bold", color: "#000", fontSize: "14px" }}>
                                                        {image.subtitle}
                                                    </Typography>
                                                </Typography>
                                            </CardContent>
                                            <CardMedia
                                                component="img"
                                                height="322px"
                                                width="50px"
                                                image={image.src}
                                                crossOrigin="anonymous" 
                                                alt={image.subtitle}
                                                sx={{ objectFit: "contain", padding: 1 }}
                                            />
                                        </Card>

                                    ))}
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            borderTop: "1px solid rgba(231, 232, 233, 1)",
                            padding: "16px 32px",
                            position: "sticky",
                            bottom: "0",
                            background: "#FFF",
                            marginTop: "auto",
                        }}>
                            <Button onClick={toggleDrawer(false)} sx={{
                                marginRight: "auto",
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "rgba(200, 23, 47, 1)",
                                textTransform: "unset",
                            }}>
                                <img style={{ marginRight: "8px" }} src={arrowred}  crossOrigin="anonymous" alt="arrowred" height={16} width={16} />
                                Back
                            </Button>
                        </Box>
                    </Box>
                </Drawer>
            ))}
        </div>
    );
};

export default RejectorDrawer;